export const DEFAULT_SERVER_URL = "wss://livekit.rtc.elevenlabs.io";
